import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Paper,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useDispatch, useSelector } from "react-redux";
import FilterIcon from "@mui/icons-material/Tune";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../components/style";
import { useNavigate } from "react-router-dom";
import { getColumnWidth } from "../../../style/datagridMQ";
import { CircleLoader } from "react-spinners";
import {
  wholesalerDeleteRequest,
  wholesalerResetState,
  wholesalerViewAllRequest,
} from "../../../redux/wholesaler/WholesalerAction";
import { filterStyles, styles } from "../../components/LoginStyles";
import CustomDataGrid from "../../constant/commondatagrid";
import Pagination from "../../constant/CommonPagenation";
import DeleteDialog from "../../constant/commonDeleteDialogBox";
import CommonSnackbar from "../../notification/Snackbar";
import LicenseDialog from "../../constant/CommonViewDialogbox";
import {
  WholesalerImageCell,
  LicenseProofCell,
} from "../../constant/imageList";
import wholesalerdefaultimage from "../../../image/wholesalerdefaultimage.jpg";

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/admin/wholesaler/edit/${user?.id}`);
  };

  const handleDelete = () => {
    onDelete(user?.id);
    handleClose();
  };

  const handleViewAll = () => {
    navigate(`/admin/wholesaler/view/${user?.id}`, {
      state: {
        vendor: user,
      },
    });
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleViewAll} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const OnBoardedWholeSaler = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [openLicenseDialog, setOpenLicenseDialog] = useState(false);
  const [selectedLicenseProof, setSelectedLicenseProof] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [emptyList, setEmptyList] = useState([]);
  const dispatch = useDispatch();

  //search
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef();

  const wholesalerViewAllState = useSelector(
    (state) => state?.wholesaler?.viewAllWholesalers || {}
  );
  const wholesalerList = wholesalerViewAllState?.data?.data || [];
  const totalRecords = wholesalerViewAllState?.data?.totalRecords || 0;
  const wholesalerPageSize = wholesalerViewAllState?.pageSize || 10;

  const wholesalerDeleteState = useSelector(
    (state) => state?.wholesaler?.deleteWholesaler || {}
  );

  const columns = (handleDeleteRow) => [
    {
      field: "prof_image",
      headerName: "Wholesaler Image",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        const imageUrl =
          params.value && params.value.trim() !== ""
            ? params.value
            : wholesalerdefaultimage;

        return (
          <WholesalerImageCell
            imageUrl={imageUrl}
            altText={params.row?.product_name || "Wholesaler"}
          />
        );
      },
    },
    {
      field: "govt_id_image",
      headerName: "License Proof",
      width: getColumnWidth("column"),
      renderCell: (params) =>
        params.value && params.value.length > 0 ? (
          <LicenseProofCell values={params.value} />
        ) : (
          <span>Proof not available</span>
          // <span style={{ color: "gray", fontStyle: "italic" }}>Proof not available</span>
        ),
    },
    {
      field: "reg_no",
      headerName: "Register No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Not Provided",
    },
    {
      field: "name",
      headerName: "Company Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Company Name Not Provided",
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "First Name Not Provided",
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Last Name Not Provided",
    },
    {
      field: "email",
      headerName: "Email",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Email Not Provided",
    },
    {
      field: "contact",
      headerName: "Phone No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Phone Number Not Provided",
    },
    {
      field: "address",
      headerName: "Address",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Address Provided",
    },
    {
      field: "tax_id",
      headerName: "Tax ID",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Tax ID Not Provided",
    },
    {
      field: "company_reg_no",
      headerName: "Company Register No",
      width: getColumnWidth("column"),
      renderCell: (params) =>
        params.value || "Company Register No Not Provided",
    },
    {
      field: "license_no",
      headerName: "License No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "License No Not Provided",
    },
    {
      field: "working_time",
      headerName: "Shop Open and Close Time",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Working Time Not Specified",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params?.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("action"),
      renderCell: (params) => (
        <ActionMenu user={params.row} onDelete={handleDeleteRow} />
      ),
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await dispatch(wholesalerViewAllRequest(currentPage));
  //   };
  //   fetchData();
  // }, [dispatch, currentPage]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      const payload = {
        pageNo: currentPage,
        search_key: searchTerm?.trim() || "",
        pagination_required: true,
      };
      dispatch(wholesalerViewAllRequest(payload));
      dispatch(wholesalerResetState());
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, currentPage]);

  useEffect(() => {
    if (wholesalerViewAllState?.success) {
      setRows(wholesalerList);
    } else {
      setRows(emptyList);
    }
  }, [wholesalerViewAllState, wholesalerList]);

  useEffect(() => {
    if (wholesalerDeleteState?.success) {
      const newPage =
        rows.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

      const payload = {
        pageNo: newPage,
        search_key: searchTerm?.trim() || "",
        pagination_required: true,
      };

      dispatch(wholesalerViewAllRequest(payload));
      dispatch(wholesalerResetState());
      setCurrentPage(newPage);
    }
  }, [wholesalerDeleteState?.success]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleDeleteRow = (id) => {
    setUserToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(wholesalerDeleteRequest(userToDelete));
    setUserToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Company Name Asc":
        sortedRows.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case "Sort by Company Name Desc":
        sortedRows.sort((a, b) => b?.name?.localeCompare(a?.name));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Grid container spacing={2} pl={6} pr={6}>
        <Grid item xs={12} sm={8} md={9} lg={9} xl={9}>
          <Box className="headingTable">
            <h1>Wholesaler Management</h1>
            <p>Here is the complete list of Wholesalers data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Company Name Asc")}
          >
            Company Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Company Name Desc")}
          >
            Company Name Z-A
          </MenuItem>
        </Menu>
        {wholesalerViewAllState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1000}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={wholesalerViewAllState?.inProgress}
                size={50}
                color="#0458d3"
              />
            </Box>
          </Box>
        )}

        {wholesalerDeleteState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1001}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={wholesalerDeleteState?.inProgress}
                size={50}
                color="#d32f2f"
              />
            </Box>
          </Box>
        )}

        <Paper>
          {/*search*/}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by company name or reg no..."
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          {wholesalerViewAllState?.inProgress ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height={300}
            >
              <CircleLoader size={50} color="#0458d3" />
            </Box>
          ) : (
            <>
              <CustomDataGrid
                rows={rows}
                columns={columns(handleDeleteRow)}
                pageSize={wholesalerPageSize}
                pagination={true}
                onSelectionModelChange={(newSelection) => {
                  setSelection(newSelection);
                }}
                rowHeight={80}
              />
              {selection.length > 0 && (
                <div>
                  <h2>Selected Rows:</h2>
                  {selection.map((id) => (
                    <div key={id}>
                      {rows.find((row) => row?.id === id).CustomerName}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </Paper>
        <Box mt={2}>
          <Grid>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecords={totalRecords}
              pageSize={wholesalerPageSize}
            />
          </Grid>
        </Box>
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={confirmDelete}
        />
        <LicenseDialog
          open={openLicenseDialog}
          onClose={() => setOpenLicenseDialog(false)}
          licenseProof={selectedLicenseProof}
        />
        <CommonSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
      </StyledContainer>
    </>
  );
};

export default OnBoardedWholeSaler;
